import React from 'react';
import { useLocation } from 'react-router';
import CultureIndexLocationControlPanel from './Location';
import CultureIndexAreaControlPanel from './Area';

export default function CultureIndexControlPanel() {
  const location = useLocation();

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {location.pathname.includes('culture-index/area') && <CultureIndexAreaControlPanel />}
      {location.pathname.includes('culture-index/location') && <CultureIndexLocationControlPanel />}
    </>
  );
}
